import {RootState} from 'redux/store';

export const getBaitCheckerState = (state: RootState) => state.inventory;

export const inventoryLoading = (state: RootState) => state.inventory.isLoading;

export const getBaitCheckerList = (state: RootState) => state.inventory.inventoryList;

export const getBaitCheckerCount = (state: RootState) => state.inventory.count;
